import React from "react";
import InfiniteScroll from "react-infinite-scroller";
import { connect } from "react-redux";

import { LoadingPage, LoadingInline } from "../common/loading";
import { commonErr } from "../common/errors";
import { MessageLine, Empty } from "../common/messagebox";
import { isEmptyObj } from "../common/common";

import CarItem from "../common/caritem";

import { TipBox } from "./components/tipbox";

import empty from "../../static/images/empty/empty-mycar.svg";

class ListView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lastId: undefined,
		};
	}

	searchCarListMore = (currentId) => {
		if (currentId !== this.state.lastId) {
			this.setState({
				lastId: currentId,
			});

			this.props.searchCarListMore({
				...this.props.carFinding.filter,
				pos: this.props.carFinding.cars.length,
				fromCarId: currentId,
			});
		}
	};

	render() {
		let content;
		const searchData = this.props.carFinding;
		const { searchTip, nonLoginProfile } = searchData;

		const { isAirDelivery, isLogged, stype } = this.props;

		if (searchData.err === commonErr.INNIT || searchData.err === commonErr.LOADING) {
			content = (
				<div style={{ paddingTop: "30vh", maxHeight: "100vh" }}>
					<LoadingPage />
				</div>
			);
		} else if (searchData.err === commonErr.FAIL && searchData.errCode <= commonErr.FAIL) {
			content = (
				<div className="list-car-section">
					<Empty img={empty} msg={searchData.errMsgBox} />
				</div>
			);
		} else if (searchData.cars) {
			const currentId = searchData.cars[searchData.cars.length - 1].id;

			content = (
				<InfiniteScroll
					pageStart={0}
					loadMore={() => this.searchCarListMore(currentId)}
					hasMore={searchData.more === 1}
					loader={
						<div key={0}>
							<LoadingInline />
						</div>
					}
					useWindow={true}>
					<div className={`list-car-section`}>
						{!isEmptyObj(searchTip) ? <TipBox searchTip={searchTip} /> : null}
						<div className="scroll-fix">
							<div className="m-container">
								<div className="col4-mg20 list-car">
									{searchData.cars.map((car) => (
										<CarItem
											key={car.id.toString()}
											car={car}
											isAirDelivery={isAirDelivery}
											togglePopup={this.props.togglePopup}
											stype={stype}
											isNewTab={true}
											isLogged={isLogged}
											showLoginForm={this.props.showLoginForm}
											fav={true}
											avatar={true}
											nonLoginProfile={nonLoginProfile}
											multiPhotos={true}
										/>
									))}
								</div>
							</div>
						</div>
					</div>
				</InfiniteScroll>
			);
		} else {
			content = (
				<div className="list-car-section">
					<Empty img={empty} msg={"Không tìm thấy xe nào"} />
				</div>
			);
		}
		return <>{content}</>;
	}
}

function mapState(state) {
	return {
		carFinding: state.carFinding,
	};
}

ListView = connect(mapState)(ListView);

export default ListView;
